import { createPrismic } from '@prismicio/vue';

const prismic = createPrismic({
  endpoint: 'investor-app',
  injectComponents: true,
});

export default prismic;
